import React from 'react';
import {goToExternalLink} from 'pages/AddPersonalDataForm/utils';
import {device} from 'styled/device';
import {useScreenResize} from './common';
import {useOpenModals} from 'context/openModals';
import {PATHS} from 'Routes';
import {IconNames} from '@guestapp/ui/src/components/CustomIcon/CustomIcon';

const faqIcon = (fill: string) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM6.21347 6.29249C6.59592 6.51372 7.0853 6.38303 7.30654 6.00058C8.07214 4.89232 9.55205 6.368 8.33868 7.08932C8.12059 7.21897 7.83537 7.43478 7.61843 7.69915C7.41302 7.94948 7.22436 8.29373 7.20218 8.71682C7.19935 8.74416 7.1979 8.77191 7.1979 8.8C7.1979 9.24183 7.55608 9.6 7.9979 9.6C8.60772 9.6 8.72379 9.27603 8.84092 8.94912C8.91627 8.73881 8.99206 8.52729 9.2 8.4C9.86129 7.99519 10.4 7.27818 10.4 6.4C10.4 5.07452 9.32548 4 8 4C7.11065 4 6.33533 4.48415 5.92157 5.19942C5.70033 5.58187 5.83102 6.07125 6.21347 6.29249ZM7.1979 11.2C7.1979 10.7582 7.55608 10.4 7.9979 10.4C8.43973 10.4 8.7979 10.7582 8.7979 11.2C8.7979 11.6418 8.43973 12 7.9979 12C7.55608 12 7.1979 11.6418 7.1979 11.2Z"
        fill={fill}
      />
    </svg>
  );
};

const languageIcon = (fill: string) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.8045 0.500243C13.6215 1.54377 15.6919 4.11393 15.9998 7.2H12.8071C12.6772 4.09533 11.7992 1.91663 10.809 0.501942L10.8045 0.500243ZM7.99995 0C5.5537 1.15358 4.87355 4.86788 4.76676 7.2H11.1977C11.086 4.76125 10.3904 1.31804 7.99995 0ZM5.1429 0.51987C4.15789 1.93498 3.28669 4.10842 3.15733 7.2H0C0.306006 4.1331 2.35261 1.57573 5.1429 0.51987ZM10.8047 15.4998C13.6217 14.4562 15.6921 11.8861 16 8.8H12.8073C12.6774 11.9047 11.7994 14.0834 10.8092 15.4981L10.8047 15.4998ZM8.00015 16C5.55389 14.8464 4.87375 11.1321 4.76695 8.8H11.1979C11.0862 11.2388 10.3906 14.682 8.00015 16ZM5.1431 15.4801C4.15809 14.065 3.28689 11.8916 3.15752 8.8H0.000196279C0.306203 11.8669 2.3528 14.4243 5.1431 15.4801Z"
        fill={fill}
      />
    </svg>
  );
};

const lockIcon = (fill: string) => {
  return (
    <svg width="14" height="16" viewBox="0 0 14 16" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.0808545 8.89368C0.197363 7.28172 1.46455 6.03022 3.07746 5.9277C4.04202 5.86639 5.22142 5.81818 6.54545 5.81818C7.86948 5.81818 9.04889 5.86639 10.0135 5.9277C11.6264 6.03022 12.8935 7.28172 13.0101 8.89368C13.0571 9.54428 13.0909 10.2436 13.0909 10.9091C13.0909 11.5746 13.0571 12.2739 13.0101 12.9245C12.8935 14.5365 11.6264 15.788 10.0135 15.8905C9.04889 15.9518 7.86949 16 6.54545 16C5.22142 16 4.04202 15.9518 3.07746 15.8905C1.46455 15.788 0.197363 14.5365 0.0808546 12.9245C0.0338308 12.2739 0 11.5746 0 10.9091C0 10.2436 0.0338308 9.54428 0.0808545 8.89368ZM8 10.1818C8 10.7202 7.70749 11.1903 7.27273 11.4418V12.3636C7.27273 12.7653 6.94712 13.0909 6.54545 13.0909C6.14379 13.0909 5.81818 12.7653 5.81818 12.3636V11.4418C5.38342 11.1903 5.09091 10.7202 5.09091 10.1818C5.09091 9.37849 5.74213 8.72727 6.54545 8.72727C7.34878 8.72727 8 9.37849 8 10.1818Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.90942 3.63636C2.90942 1.62806 4.53748 0 6.54579 0C8.5541 0 10.1822 1.62806 10.1822 3.63636V6.54545C10.1822 6.94712 9.85654 7.27273 9.45488 7.27273C9.05322 7.27273 8.72761 6.94712 8.72761 6.54545V3.63636C8.72761 2.43138 7.75077 1.45455 6.54579 1.45455C5.3408 1.45455 4.36397 2.43138 4.36397 3.63636V6.54545C4.36397 6.94712 4.03836 7.27273 3.6367 7.27273C3.23503 7.27273 2.90942 6.94712 2.90942 6.54545V3.63636Z"
        fill={fill}
      />
    </svg>
  );
};

export enum NavLinks {
  home = 'home',
  onlineCheking = 'online_chekin',
  virtualKeys = 'virtual_keys',
  homebook = 'hoomebook',
  language = 'language',
  privacy = 'privacy_policy',
  faq = 'faqs',
  paymentCart = 'payment_cart',
}

type navigatorLinksProps = {
  languageClick?: () => void;
};
function useNavigationLinks({languageClick}: navigatorLinksProps) {
  const {isMatch: isMobileMode} = useScreenResize(device.mobileXL);
  const {checkIfOpenDiscardModalAndRedirect} = useOpenModals();

  const navigatorLinks = React.useMemo(() => {
    const color = isMobileMode ? '#393ABD' : '#A8ADC7';

    const navigatorLinks = {
      [NavLinks.language]: {
        label: NavLinks.language,
        selected: false,
        disabled: false,
        icon: languageIcon(color),
        iconName: 'languageSidebar' as IconNames,
        onclick: languageClick || (() => undefined),
      },
      [NavLinks.privacy]: {
        label: 'privacy_policy',
        selected: false,
        disabled: false,
        icon: lockIcon(color),
        iconName: 'lockSidebar' as IconNames,
        onclick: () =>
          goToExternalLink(
            'https://chekin.com/en/generic-privacy-policy-of-accommodations/',
          ),
      },
      [NavLinks.faq]: {
        label: NavLinks.faq,
        selected: false,
        disabled: false,
        icon: faqIcon(color),
        iconName: 'questionCircle' as IconNames,
        onclick: () => checkIfOpenDiscardModalAndRedirect(PATHS.faq),
      },
    };

    return navigatorLinks;
  }, [isMobileMode, languageClick, checkIfOpenDiscardModalAndRedirect]);

  const navigatorLinksArray = React.useMemo(() => {
    return Object.values(navigatorLinks);
  }, [navigatorLinks]);

  return {navigatorLinksArray};
}

export {useNavigationLinks};
